import initialState from '../../reducers/initialState';
import * as types from 'actions/actionTypes';

export default function (state = initialState.reducerTasks, action) {
    switch (action.type) {
        case types.TASK_LIST_UPDATE:
            return {
                taskList: action.payload ? action.payload : [{}],
            }
        default:
            return state;
    }
}
